import { render, staticRenderFns } from "./massolino.vue?vue&type=template&id=0685352b&scoped=true"
import script from "./massolino.vue?vue&type=script&lang=js"
export * from "./massolino.vue?vue&type=script&lang=js"
import style0 from "./massolino.vue?vue&type=style&index=0&id=0685352b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0685352b",
  null
  
)

export default component.exports